import { Injectable } from '@angular/core';
import { ButtonName } from '@app/components/booking-flow/booking-flow.component';
import { Subject } from 'rxjs';

export interface DsbStep {
    stepRoute: string;
    buttonText: string;
    index: number;
}

// 2025 Redesign Project Note - This service is obsolete in the redesigned flow and should
// be removed when updating redesign components that use it.  Do NOT at this service to any
// redesign components.
@Injectable({
    providedIn: 'root',
})
export class ContentService {
    public readonly logout = 'logout';
    public buttonName: string = ButtonName.SelectEmployee;
    public selectedStepIndex: number = 0;
    public isStepCompleted = 0;
    public isAccountCreatedFromClientScreen = false;
    public steps: DsbStep[] | undefined;
    private dataSubject = new Subject<any>();
    public dataUpdated$ = this.dataSubject.asObservable();
    public sendData = (data: any) => this.dataSubject.next(data);
}
